import { render, staticRenderFns } from "./HeaderRestaurantTitle.vue?vue&type=template&id=1ffa907c&scoped=true"
import script from "./HeaderRestaurantTitle.vue?vue&type=script&lang=js"
export * from "./HeaderRestaurantTitle.vue?vue&type=script&lang=js"
import style0 from "./HeaderRestaurantTitle.vue?vue&type=style&index=0&id=1ffa907c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa907c",
  null
  
)

export default component.exports